import * as React from 'react';
import { useEffect, useState } from 'react';
import { useContent } from '../../Content/cms';
import Apirest from '../../Content/Apirest';

import DataFrame from '../../Commons/Components/DataFrame';
import Modal from 'react-bootstrap/Modal';
import { IconButton } from '../../Commons/MultipleComponents';
import { faDownload, faAngry, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import { PopUpError, PopUpSuccess } from '../../Commons/Helpers';


import moment, { Moment } from 'moment';
import RenderIfManager from '../../Admin/RenderIfManager';


/** Deprecate the fields at the end and bring all the examiner info as it could be different that the user */

interface Takeout {
    id: number
    uuid: string
    file_name: string
    created_at: Moment
    updated_at: Moment
    deleted_at: null | Moment
    status: "failed" | "complete" | "pending"
    examiner: number

    md5: null    
    number_of_times_request_presigned: number
    size: number
    user: number
    start_date?: string
    end_date?: string
}

const Takeout : React.FC = () => {

    const mobiles = require('is-mobile');
    let mobile = mobiles();
    let getContent = useContent();

    let [show, setShow] = useState<boolean>(false);
    let [creating, setCreating] = useState<boolean>(false);
    let [takeouts, setTakeouts] = useState<Takeout[]>([]);
    let [orgTakeouts, setOrgTakeouts] = useState<Takeout[]>([]);

    const [monthOptions] = useState<{ value: string, label: string }[]>(() => {
        const today = moment();
        const options: { value: string, label: string }[] = [
        { value: '', label: getContent('takeout__modal__all_dates') } 
    ];;
        for (let i = 0; i < 24; i++) {
            const date = today.clone().subtract(i, 'months');
            options.push({
                value: date.format('YYYY-MM'),
                label: date.format('MMMM YYYY')
            });
        }
        return options;
    });
    const [selectedMonth, setSelectedMonth] = useState<string>(monthOptions[0].value);
    const [includeAudio, setIncludeAudio] = useState<boolean>(true);


    useEffect(getTakeouts, []);

    useEffect(
        () => {
            if (takeouts.some(t => t.status === 'pending')) {
                setTimeout(getTakeouts, 30*1000);
            }
        }, [takeouts]
    )

    useEffect(getOrgTakeouts, []);

    useEffect(
        () => {
            if (orgTakeouts.some(t => t.status === 'pending')) {
                setTimeout(getTakeouts, 30*1000);
            }
        }, [orgTakeouts]
    )

    function getTakeouts() {
        Apirest.get_all_takeouts(setTakeouts);
    }

    function getOrgTakeouts() {
        Apirest.get_all_org_takeouts(setOrgTakeouts);
    }

    function getMonthRange(month: string) {
        if (!month) return {};
        const [year, m] = month.split('-');
        const start = moment(`${year}-${m}-01`);
        let end = start.clone().endOf('month');
        const today = moment();
        if (start.isSame(today, 'month')) {
            end = today;
        }
        return {
            startDate: start.format('YYYY-MM-DD'),
            endDate: end.format('YYYY-MM-DD')
        };
    }

    function createTakeout() {
        setCreating(true);
        const monthRange = selectedMonth ? getMonthRange(selectedMonth) : {};
        const startDate = monthRange ? monthRange.startDate : undefined;
        const endDate = monthRange ? monthRange.endDate : undefined;
        Apirest.create_takeout(
            () => {
                setCreating(false);
                PopUpSuccess(getContent('takeout__modal_success'));
                getTakeouts();
            },
            (response) => {
                setCreating(false);
                PopUpError(
                    getContent('takeout__modal__error__' + response.responseJSON.error)
                )
            },
            includeAudio,
            startDate,
            endDate
         );
    }

    function createOrgTakeout() {
        setCreating(true);
        const monthRange = selectedMonth ? getMonthRange(selectedMonth) : {};
        const startDate = monthRange ? monthRange.startDate : undefined;
        const endDate = monthRange ? monthRange.endDate : undefined;
        Apirest.create_org_takeout(
            () => {
                setCreating(false);
                PopUpSuccess(getContent('takeout__modal_success'));
                getOrgTakeouts();
            },
            (response) => {
                setCreating(false);
                PopUpError(
                    getContent('takeout__modal__error__' + response.responseJSON.error)
                )
            },
            includeAudio,
            startDate,
            endDate
         );
    }

    const ICONS = {
        'failed': faAngry,
        'complete': faDownload,
        'pending': faHourglassHalf
    }

    /** Apirest download_takeout will silent fail if not completed
        and then no action will be taken as expected. 
        Thus, no need to check if status complete for the onClick action */
    function takeout2row(takeout: Takeout) {
        return [
            <div>{takeout.created_at.format('LL')}</div>,
            <div>{(takeout.start_date || takeout.end_date) ? `${takeout.start_date || ''} - ${takeout.end_date || ''}` : getContent('takeout__modal__all_dates')}</div>,
            <IconButton
                onClick={() => Apirest.download_takeout(takeout.uuid)}
                icon={{ icon: ICONS[takeout.status], color: "#5CB6E7"}}
                text={getContent('takeout__tooltip__' + takeout.status)}
            />
        ]
    }

    function allTakeout2Row(takeouts: Takeout[]) {
        return takeouts.map(takeout => takeout2row(takeout));    
    }

    function creationDisabled() {
        // We keep this function to have the structure in case we neew
        // a fallback
        return false;
    }

    // Return a modal with the data of the takeouts in a dataframe
    return <>
        <button onClick={() => setShow(true)} className={'link-button'}>
            {getContent('takeout__menu__btn')}
        </button>
        <Modal show={show} onHide={() => setShow(false)} size={'lg'} centered >
            <Modal.Header closeButton>
                <Modal.Title>{getContent('takeout__modal__title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Container className={'p-3'} >

                    <Row className={'mb-3'}>
                        <Alert variant="info" className="d-flex align-items-center">
                            <div>
                                {getContent('takeout__modal__infrastructure_warning')}
                            </div>
                        </Alert>
                    </Row>

                    <Row className={'mb-3'}>
                        <div dangerouslySetInnerHTML={{__html: getContent('takeout__modal__body')}} />
                    </Row>
                    <Row className={'mb-3'}>
                        <Col md={6}>
                            <label>{getContent('takeout__modal__select_month')}</label>
                            <select
                                value={selectedMonth}
                                onChange={e => setSelectedMonth(e.target.value)}
                                className="form-select"
                                style={{ minWidth: 200 }}
                            >
                                {monthOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </Col>
                        <Col md={6}>
                            <label style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                    type="checkbox"
                                    checked={includeAudio}
                                    onChange={e => setIncludeAudio(e.target.checked)}
                                    style={{ marginRight: '0.5rem' }}
                                />
                                {getContent('takeout__modal__include_audio')}
                            </label>
                        </Col>
                    </Row>
                    <Container className={'border-bototm'}>
                    <Row>
                        <h3 className={'text-primary'}>{getContent('takeout__modal__examiner_takeouts__subtitle')}</h3>
                    </Row>
                    <Row>
                        <div style={{width: '100%'}}>
                            <b>{getContent('takeout__modal__date_range_column')}</b>: {selectedMonth ? (() => {
                                const start = moment(selectedMonth + '-01');
                                const today = moment();
                                const end = start.isSame(today, 'month') ? today : start.clone().endOf('month');
                                return `${start.format('YYYY-MM-DD')} - ${end.format('YYYY-MM-DD')}`;
                            })() : getContent('takeout__modal__all_dates')}
                        </div>
                    </Row>
                    <Row className={'pt-3'}>
                        {takeouts.length > 0 && <DataFrame
                            header={[getContent('takeout__modal__created_at_column'), getContent('takeout__modal__date_range_column'), getContent('takeout__modal__actions_column')]}
                            dataframe={allTakeout2Row(takeouts)}
                            pageSize={5}
                            striped={true}
                            clickeableRow={true}
                            columnClassName={'text-right'}
                        />}
                        <Button 
                            onClick={createTakeout}
                            disabled={creationDisabled()}
                            className={mobile ? 'w-100' : 'w-50'}
                            >
                            {!creating && getContent('takeout__modal__create_btn')}
                            {creating && <Spinner animation="border" variant="primary" />}
                        </Button>

                        {takeouts.length === 0 && <div>
                            <Alert variant={'warning'} className={'p-3 w-100'}>
                                {getContent('takeout__modal__empty')}
                            </Alert>
                        </div>}
                    </Row>
                    </Container>
                    <RenderIfManager>
                        <Container className={'mt-3'}>
                            <Row className={'mt-3'}>
                                <h3 className={'text-primary'}>{getContent('takeout__modal__org_takeouts__subtitle')}</h3>
                            </Row>
                            <Row className={'pt-3'}>
                                {orgTakeouts.length > 0 && <DataFrame
                                    header={[getContent('takeout__modal__created_at_column'), getContent('takeout__modal__date_range_column'), getContent('takeout__modal__actions_column')]}
                                    dataframe={allTakeout2Row(orgTakeouts)}
                                    pageSize={5}
                                    striped={true}
                                    clickeableRow={true}
                                    columnClassName={'text-right'}
                                />}
                                <Button
                                    onClick={createOrgTakeout}
                                    disabled={creationDisabled()}
                                    className={mobile ? 'w-100' : 'w-50'}
                                >
                                    {!creating && getContent('takeout__modal__create_btn')}
                                    {creating && <Spinner animation="border" variant="primary" />}
                                </Button>

                                {orgTakeouts.length === 0 && <div>
                                    <Alert variant={'warning'} className={'p-3 w-100'}>
                                        {getContent('takeout__modal__empty')}
                                    </Alert>
                                </div>}
                            </Row>
                        </Container>
                    </RenderIfManager>
                </Container>
            </Modal.Body>
        </Modal>
    </>;
}

export default Takeout;